import { useEffect } from "react";
import { useSelector } from "react-redux";
import withNavigate from "../hocs/withNavigate";

const ProtectedRoute = ({ children, navigate }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) return null;

  return children;
};

export default withNavigate(ProtectedRoute);
